export function useMesh() {
  const url = window.location.origin;
  return { url };
}
